import { client } from '../../..'
import { EMPLOYEES_BY_NAME } from '../../../graphql/employee/Queries'
import { EmployeeNameSearchInfo, EmployeeByNameQuery, EmployeeByNameQueryVariables } from '../../../types'

// fetches employeeNames via apollo client
// only used in EmployeeSearchSelect
export const getEmployeesByNameSearch = async (
  callback: (any: EmployeeNameSearchInfo[]) => void,
  searchString: string,
  limit?: number,
): Promise<void> => {
  const result = await client.query<EmployeeByNameQuery, EmployeeByNameQueryVariables>({
    query: EMPLOYEES_BY_NAME,
    variables: {
      searchString: searchString,
      limit: limit,
    },
  })

  const { errors, data, loading } = result
  if (!errors && !loading && data && data.nameSearch) callback(data.nameSearch)
}
